import {
  ETAT_BROUILLON,
  ETAT_ENREGISTRE,
  ETAT_PAYE,
  REGROUPEMENT,
  NORMAL,
  TYPE_FACTURE,
} from '@/configuration/devisConf';
import { VENTE } from '@/configuration/parametrage/schemaComptableConf';

export default function critereRechercheBaseFacture(criteresRecherche) {
  if (criteresRecherche.etat && criteresRecherche.etat.length > 0) {
    criteresRecherche.etatsDevisCommandeFacture = criteresRecherche.etat.map((item) => (typeof item === 'object' ? item.code : item),
    );
  } else {
    criteresRecherche.etatsDevisCommandeFacture = [ETAT_BROUILLON, ETAT_ENREGISTRE, ETAT_PAYE];
  }
  criteresRecherche.type = TYPE_FACTURE;
  criteresRecherche.typesDevisCommandeFacture = [TYPE_FACTURE];
  criteresRecherche.sens = VENTE;
  criteresRecherche.types = [REGROUPEMENT, NORMAL];
  criteresRecherche.isWithProduitDivers = true;
}
